export default __webpack_public_path__ + "static/media/app2-24.bfb8005b.jpg";